__turbopack_context__.v({
  "className": "amiri_a4a8c1fa-module__szoeCq__className",
  "variable": "amiri_a4a8c1fa-module__szoeCq__variable",
});
